import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Pencil = createSvgIcon(React.createElement("path", { d: "M16.9,2.4L3.7,15.6l-1.2,5.8l5.8-1.2L21.6,7.1L16.9,2.4z M18.7,7.1l-1.1,1.1l-1.8-1.8l1.1-1.1L18.7,7.1z\n\t    M7.4,18.4l-2.3,0.5l0.5-2.3l8.8-8.8l1.8,1.8L7.4,18.4z" }), 'Pencil');
export default Pencil;
